import apiBase from 'src/api/api-base';
import { endpoints } from 'src/config/endpoints';
import Log from 'src/models/log';

const appendValue = (formData: FormData, key: string, value: any) => {
  if (value === undefined || value === null || value === '') return;
  formData.append(key, value.toString());
};

/**
 * Il LOG ha blocchi annidati (+ eventuale immagine certificato) -> sempre FormData.
 * In edit si usa method spoofing (Laravel non legge i file su PUT puro).
 */
const buildFormData = (log: any, method?: 'PUT'): FormData => {
  const formData = new FormData();
  if (method) {
    formData.append('_method', method);
  }

  appendValue(formData, 'name', log.name);
  appendValue(formData, 'serial', log.serial);
  appendValue(formData, 'atm_serial', log.atm_serial);
  appendValue(formData, 'atm_linearity', log.atm_linearity);

  (log.blocks ?? []).forEach((block: any, index: number) => {
    appendValue(formData, `blocks[${index}][pressure_serial]`, block.pressure_serial);
    appendValue(formData, `blocks[${index}][pressure_linearity]`, block.pressure_linearity);
    appendValue(formData, `blocks[${index}][temperature_serial]`, block.temperature_serial);
    appendValue(formData, `blocks[${index}][temperature_linearity]`, block.temperature_linearity);
  });

  // Immagine: si invia solo se nuova (File). Le stringhe URL esistenti non si re-inviano.
  if (log.calibration_certificate instanceof File) {
    formData.append('calibration_certificate', log.calibration_certificate);
  }

  return formData;
};

export const getAllLogs = async (): Promise<Log[]> =>
  new Promise((resolve, reject) => {
    apiBase
      .get(endpoints.logs.getAll)
      .then((response) => resolve(response.data as Log[]))
      .catch(reject);
  });

export const createLog = async (log: any): Promise<Log> =>
  new Promise((resolve, reject) => {
    apiBase
      .post(endpoints.logs.create, buildFormData(log))
      .then((response) => resolve(response.data as Log))
      .catch(reject);
  });

export const updateLog = async (log: any): Promise<Log> =>
  new Promise((resolve, reject) => {
    apiBase
      .post(endpoints.logs.update(log.id), buildFormData(log, 'PUT'))
      .then((response) => resolve(response.data as Log))
      .catch(reject);
  });

export const deleteLog = async (id: number | string): Promise<Log> =>
  new Promise((resolve, reject) => {
    apiBase
      .delete(endpoints.logs.delete(id))
      .then((response) => resolve(response.data as Log))
      .catch(reject);
  });
